import React from 'react'
import { LuSquare, LuSquareCheck } from 'react-icons/lu'

import { ReferralsImportItem } from '@/redux/slices/referralsImportBase'
import { ModifierKey } from '@/types/misc'

interface Props {
  importItem: ReferralsImportItem
  handleSelect: (refUUID: string, modifier: null | ModifierKey) => void
}

const SelectCell: React.FC<Props> = ({ importItem, handleSelect }) => {
  return (
    <button
      className="text-body-base flex items-center justify-center border-0"
      style={{
        width: '40px',
        height: '45px',
        background: 'none',
        outline: 'none',
      }}
      onMouseDown={(event) => {
        if (event.shiftKey) {
          event.preventDefault()
        }
      }}
      onClick={(event) => {
        event.preventDefault()
        handleSelect(
          importItem.refUUID,
          event.altKey
            ? 'altKey'
            : event.ctrlKey
              ? 'ctrlKey'
              : event.metaKey
                ? 'metaKey'
                : event.shiftKey
                  ? 'shiftKey'
                  : null,
        )
        return false
      }}
    >
      {importItem.selected ? <LuSquareCheck /> : <LuSquare />}
    </button>
  )
}

export default SelectCell
